import { MultiSearchQueryWithFederation } from 'meilisearch';
import { SearchCollection } from './interfaces/search.interface';
import { buildNotesSearchFilter } from './notes-search-filter.builder';

export interface CollectionQuery {
  search: string;
  collections: SearchCollection[];
  /** When set, notes queries use the full author/visibility filter. */
  currentUserId?: string;
}

const notesFilter = (currentUserId: string | undefined): string =>
  currentUserId ? buildNotesSearchFilter(currentUserId) : 'relatedTo IS NOT NULL AND visibility = "shared"';

const mapMulti =
  (query: CollectionQuery) =>
  (col: SearchCollection): MultiSearchQueryWithFederation => ({
    indexUid: col.value,
    q: query.search,
    attributesToHighlight: ['*'],
    highlightPreTag: '<strong>',
    highlightPostTag: '</strong>',
    federationOptions: {
      weight: col.weight,
    },
    ...(col.value === 'notes' ? { filter: notesFilter(query.currentUserId) } : {}),
  });

export function searchQueryBuilder(query: CollectionQuery): MultiSearchQueryWithFederation[] {
  const result = query.collections.map(mapMulti(query));
  return result;
}
